module.exports = __webpack_public_path__ + "img/veranda.e19db63b.svg";